export default class AdminPrescriptions {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminPrescriptionsEndpoint, {
      params
    })
  }

  fetch(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminPrescriptionsEndpoint}/${id}`, {})
  }

  create(payload = {}) {
    return this.axiosIns.post(`${this.jwtConfig.main.adminPrescriptionsEndpoint}`, payload)
  }

  attachNote(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPrescriptionsEndpoint}/${id}/attach-note`, payload, {})
  }

  markAsProcessing(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPrescriptionsEndpoint}/${id}/process`, {})
  }

  markAsDelivered(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPrescriptionsEndpoint}/${id}/deliver`, {})
  }

  markAsOutOfStock(id) {
    return this.axiosIns.put(`${this.jwtConfig.main.adminPrescriptionsEndpoint}/${id}/mark-as-out-of-stock`, {})
  }
}
